import React, { useEffect, useState } from 'react';
import HomeMain from './HomeMain';
import Footer from './footer';
import HeaderStyleOne from './HeaderStyleOne';
import BackToTop from './BackToTop';


const LandingPage = () => {
    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener("scroll", handleScroll);
        return () => document.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <React.Fragment>
            <HeaderStyleOne />
             <HomeMain />
            <BackToTop scroll={isVisible} />
            <Footer />
        </React.Fragment>
    );
}

export default LandingPage;
